/* eslint-disable no-undef */
import ListingHit from '../listing/listing-hit';
import {Marker, Overlay} from '@homeaway/react-google-maps';
import {withUser} from '../user/user';
import {ROLES} from '../../utils/constants';
import React from 'react';

export const HA_CORE_BLUE = '#0067db';

export function mapPin(props = {}) {
    /* istanbul ignore next */
    const fillColor = props && props.fillColor || HA_CORE_BLUE;
    /* istanbul ignore next */
    const strokeColor = props && props.strokeColor || '#FFF';
    /* istanbul ignore next */
    return {
        anchor: new google.maps.Point(27, 32),
        path:
            'M 26.93,32.18 C 26.37,31.37 25.82,30.54 25.29,29.72 24.03,27.79 22.82,25.82 21.68,23.83 21.01,22.67 20.37,21.49 19.77,20.30 17.68,16.26 16.50,13.07 16.50,11.10 16.50,5.24 21.24,0.50 27.10,0.50 32.95,0.50 37.69,5.24 37.69,11.10 37.69,13.07 36.51,16.26 34.43,20.33 33.81,21.52 33.16,22.70 32.49,23.82 31.35,25.82 30.12,27.81 28.89,29.71 28.46,30.37 28.06,30.97 27.70,31.51 27.70,31.51 27.25,32.17 27.25,32.17 27.13,32.34 27.06,32.34 26.95,32.18 26.95,32.18 26.95,32.18 26.95,32.18 26.95,32.18 26.93,32.18 26.93,32.18 Z M 26.93,32.18 C 26.37,31.37 25.82,30.54 25.29,29.72 24.03,27.79 22.82,25.82 21.68,23.83 21.01,22.67 20.37,21.49 19.77,20.30 17.68,16.26 16.50,13.07 16.50,11.10 16.50,5.24 21.24,0.50 27.10,0.50 32.95,0.50 37.69,5.24 37.69,11.10 37.69,13.07 36.51,16.26 34.43,20.33 33.81,21.52 33.16,22.70 32.49,23.82 31.35,25.82 30.12,27.81 28.89,29.71 28.46,30.37 28.06,30.97 27.70,31.51 27.70,31.51 27.25,32.17 27.25,32.17 27.13,32.34 27.06,32.34 26.95,32.18 26.95,32.18 26.95,32.18 26.95,32.18 26.95,32.18 26.93,32.18 26.93,32.18 Z',
        fillColor,
        fillOpacity: 1,
        strokeColor
    };
}

export function MapMarker({
    icon,
    listing,
    map,
    onClick,
    showOverlay,
    user,
    ...rest
}) {
    const {geoCode, unitUuid} = listing || {};
    const {latitude, longitude} = geoCode || {};
    const {role: {type: roleType = ''} = {}} = user || {};
    const showCollaborationToolbar = (roleType === ROLES.COLLABORATOR || roleType === ROLES.OWNER);
    const pixelOffset = new google.maps.Size(-130, showCollaborationToolbar ? -352 : -315);
    const handleClick = (e) => {
        if (onClick) {
            onClick(e, {unitUuid});
        }
    };
    if (!latitude) {
        return null;
    }
    return (
        <Marker
            {...rest}
            icon={icon}
            id={unitUuid}
            map={map}
            onClick={handleClick} // eslint-disable-line react/jsx-no-bind
            position={{
                lat: latitude,
                lng: longitude
            }}
        >
            {showOverlay &&
                <Overlay map={map} pixelOffset={pixelOffset}>
                    <ListingHit
                        showCollaborationToolbar={showCollaborationToolbar}
                        {...listing}
                    />
                </Overlay>
            }
        </Marker>
    );
}

export default withUser(MapMarker);



// WEBPACK FOOTER //
// ./src/universal/tripboard/listings-map/map-marker.js